import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
import { IMatterType } from '../interface/matter-types';

interface IGetMatterTypeById {
  id?: string;
  relations?: string[];
  fields?: string[];
}
export const useGetMatterTypeById = (params: IGetMatterTypeById) => {
  const { id, ...queryParams } = params;
  const queryString = Object.keys(queryParams)?.length
    ? toQueryString(queryParams as QueryParamObject)
    : null;
  const matterTypeUrl = `${API_URLS.MATTER_TYPES_LIST}/${id}`;
  const url = queryString ? `${matterTypeUrl}?${queryString}` : matterTypeUrl;
  const query = useQuery<IMatterType, Error>({
    queryKey: ['matter-type-details', id],
    queryFn: async () => {
      const response = await get(url);
      return response;
    },
    enabled: !!id,
  });

  return query;
};
